<template>
  <div
    class="min-h-screen flex flex-col items-center justify-center py-6 px-4 sm:px-6 lg:px-8 bg-lightGray bg-cover bg-center relative overflow-hidden"
  >
    <div
      v-if="accessSyncPending"
      class="flex flex-col items-center justify-center gap-4 text-gray-600"
      aria-live="polite"
    >
      <Loader2 class="h-10 w-10 animate-spin text-cosmicPurple" />
      <p class="text-sm">Checking access…</p>
    </div>

    <div
      v-else
      class="max-w-xl w-full space-y-8 bg-white/80 backdrop-blur-xl p-8 rounded-2xl overflow-hidden shadow-2xl shadow-cosmicPurple/10 relative z-10"
    >
      <ShineBorder
        :border-width="2"
        :duration="24"
        :shine-color="SHINE_COLORS"
      />

      <div class="relative flex items-center justify-center">
        <div
          class="absolute -top-[25rem] z-10 bg-[#4d7aff] w-[30rem] h-[30rem] rounded-full blur-[100px] opacity-30 appear"
        />
        <img
          src="/tracktalent_logo.svg"
          alt="Logo"
          class="h-10 mx-auto z-20"
        />
      </div>

      <h2 class="mt-6 text-center text-2xl text-gray-900">
        {{ pageTitle }}
      </h2>

      <div class="mt-8 space-y-4">
        <p class="text-md text-gray-600 text-center">
          {{ message }}
        </p>
      </div>

      <div class="mt-6 flex flex-col gap-3">
        <button
          type="button"
          class="w-full bg-cosmicPurple shadow-lg shadow-cosmicPurple/20 text-white hover:bg-cosmicPurple/90 hover:-translate-y-[1px] transition-all duration-200 py-2 px-4 border border-transparent rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          @click="handleAction"
        >
          {{ buttonText }}
        </button>
        <button
          type="button"
          class="w-full bg-white text-gray-600 hover:text-gray-900 hover:bg-gray-100 hover:-translate-y-[1px] transition-all duration-200 py-2 px-4 border border-gray-300 rounded-md text-sm font-medium focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          @click="handleLogout"
        >
          Log out
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Loader2 } from 'lucide-vue-next'
import ShineBorder from '@/components/ui/ShineBorder.vue'
import { usePermissionDeniedView } from '@/composables/usePermissionDeniedView'

const SHINE_COLORS = ['#A07CFE', '#FE8FB5', '#FFBE7B']

const { accessSyncPending, pageTitle, message, buttonText, handleAction, handleLogout } =
  usePermissionDeniedView()
</script>

<style scoped>
.appear {
  animation: appear 1.5s ease-in-out;
}

@keyframes appear {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  100% {
    opacity: 0.3;
    transform: scale(1);
  }
}
</style>
